import { useQuery } from '@tanstack/react-query';
import * as Api from '../api';

interface IProps {
  enabled?: boolean;
}

const useOverview = ({ enabled = true }: IProps = {}) => {
  const query = useQuery({
    queryKey: ['teams', 'overview'],
    queryFn: async () => {
      const response = await Api.overview();
      return response.data.data;
    },
    enabled,
  });

  return {
    overview: query.data,
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch,
  };
};

export default useOverview;
